import env from 'env-var'

const config = Object.freeze({
  baseURL: env.get('REACT_APP_API_RATAIL_BASE_URL').asUrlString()
})

export default config
